export type UserCredentials = {
  email: string;
  password: string;
};

export type UserIdentifiers = {
  email: string;
  cdcId: string;
};

export type UserAppliancesResponse = {
  body?: UserAppliancesData;
  status: number;
};

export type UserAppliancesData = {
  user: CdcUser;
  appliances: RegisteredAppliance[];
};

export type CdcUser = {
  userId: string;
  email: string;
  countryCode: string;
  dataCenter: string;
  createdAt: string;
};

export type RegisteredAppliance = {
  applianceId: string;
  applianceName: string;
  modelName: string;
  applianceType: string;
  created: Date;
  timeZone: string;
};

export type EcpApplianceResponse = {
  body?: EcpApplianceData;
  status: number;
};
export type ApplianceType = {
  applianceType: string;
};
export type EcpApplianceData = {
  applianceType: ApplianceType;
  enrollment: EcpEnrollmentStatus;
};

export type EcpAppliance = {
  applianceId: string;
  applianceName: string;
  modelName: string;
  applianceType: string;
  created: Date;
  timeZone: string;
};

export type EcpEnrollmentStatus = {
  enrolled: boolean;
  errorMessage: string;
  statusCode: number;
};

export type ApplianceOwner = {
  email: string;
  cdcId: string;
};

export type CasApplianceResponse = {
  body?: CasApplianceData;
  status: number;
};

export type CasApplianceData = {
  applianceId: string;
  applianceName: string;
  domainId: string;
  domainName: string;
  ownerId: string;
  isOwner: boolean;
  registrationTime: Date;
  users: { userId: string; role: string }[];
};

export type DamsApplianceResponse = {
  body?: DamsApplianceData;
  status: number;
};

export type DamsApplianceData = {
  applianceID: string;
  unitType: string;
  applianceTypeID: number;
  applianceTypeDescription: string;
  isStaging: boolean;
  blackListStateDescription: string;
  currentConfigurationDate: Date;
  currentConfigurationANC: string;
  lastConnectTms: Date;
  enrollments: DamsEnrollmentInfo[];
  insertBy: string;
  insertDate: Date;
  modifiedBy: string;
  modifiedDate: Date;
};

type DamsEnrollmentInfo = {
  ecpProviderID: string;
  enrollStateDescription: string;
  enrollStateDate: Date;
  errorCode: string;
  errorMessage: string;
};

export type UnregisterApplianceResponse = {
  body?: void;
  status: number;
};

export type RegisterApplianceResponse = {
  body?: RegisterApplianceData;
  status: number;
};

export type RegisterApplianceData = {
  newFirmwareName: string;
};

export type RegisterRequest = {
  userCredentials: UserCredentials;
  applianceName: string;
};

export type UnregisterRequest = {
  userCredentials: UserCredentials;
};

export class ResponseError extends Error {
  response: Response;

  constructor(message: string, res: Response) {
    super(message);
    this.response = res;
  }
}
